<script setup lang="ts">
import { cloudUpload, personAdd, arrowBack } from "ionicons/icons";
import {
  IonContent,
  IonPage,
  IonFooter,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonIcon,
  IonCardContent,
  onIonViewWillEnter,
} from "@ionic/vue";
import { useRoute } from "vue-router";

import { useContextStore } from "@/stores/context";
import { useWindowWidth } from "@/composition/window";

const { isMobile } = useWindowWidth();
const contextStore = useContextStore();
const route = useRoute();
const event_id = parseInt(route.params.event_id as string, 10);

onIonViewWillEnter(async () => {
  contextStore.getEvent(event_id);
});
</script>

<template>
  <ion-page>
    <ion-content>
      <div class="container">
        <div
          class="flex-desktop"
          style="align-items: center"
          :style="isMobile ? '' : 'position: relative; left: -75px;'"
        >
          <ion-fab-button
            v-if="!isMobile"
            color="primary"
            style="margin-right: 20px"
            @click="$router.go(-1)"
          >
            <ion-icon :icon="arrowBack"></ion-icon>
          </ion-fab-button>
          <h1 class="ion-margin-bottom">Choose a way to create new visitors</h1>
        </div>
        <ion-card
          :router-link="`/event/${contextStore.event.id}/import-visitors`"
        >
          <ion-card-header>
            <ion-card-subtitle>
              <ion-icon :icon="cloudUpload"></ion-icon>
            </ion-card-subtitle>
            <ion-card-title> Import spreadsheet </ion-card-title>
          </ion-card-header>

          <ion-card-content>
            <p>Add a guest list from an .xls or .xlsx file.</p>
          </ion-card-content>
        </ion-card>
        <ion-card :router-link="`/event/${contextStore.event.id}/new-visitor`">
          <ion-card-header>
            <ion-card-subtitle>
              <ion-icon :icon="personAdd"></ion-icon>
            </ion-card-subtitle>
            <ion-card-title> Add individual visitors </ion-card-title>
          </ion-card-header>

          <ion-card-content>
            <p>Manually add visitors to your event.</p>
          </ion-card-content>
        </ion-card>
      </div>
    </ion-content>
    <ion-footer>
      <p class="ion-text-center ion-padding">
        This event has a capacity for
        <b>{{ contextStore.event.capacity }} visitors</b>.
      </p>
    </ion-footer>
  </ion-page>
</template>
